import useMonolithApiQuery, { UseMonolithApiQueryOptions } from '@/hooks/api/useMonolithApiQuery';

type AIConversationTurnPayloadResponse = string;

export const getAIConversationTurnPayloadPath = ({ ciConfigSlug, turnId }: { ciConfigSlug: string; turnId: string }) =>
  `/apps/${ciConfigSlug}/agent_runs/conversations/turns/${turnId}/response_payload?ai_run_type=ci-config-expert`;

const useAIConversationTurnPayload = (
  { ciConfigSlug, turnId }: { ciConfigSlug: string; turnId: string },
  opts?: UseMonolithApiQueryOptions<AIConversationTurnPayloadResponse, unknown>,
) =>
  useMonolithApiQuery<AIConversationTurnPayloadResponse, unknown>(
    ['ci-config-expert', ciConfigSlug, 'turn-payload', turnId],
    getAIConversationTurnPayloadPath({ ciConfigSlug, turnId }),
    opts,
  );

export default useAIConversationTurnPayload;
